/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualWorkingCapitalDto } from '../../models/backend-actual-working-capital-dto';
import { BackendActualWorkingCapitalRequestDto } from '../../models/backend-actual-working-capital-request-dto';

export interface MonitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualWorkingCapitalRequestDto;
}

export function monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualWorkingCapitalDto>;
    }),
  );
}

monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded.PATH = '/api/monitoring/actuals/working-capital/';
